import React, { FunctionComponent } from "react";

/**
 *
 * BUG: announcement icon falsch geschrieben
 * IMPORVMENT: create icon build pipeline
 */

export interface ImpressumProps {
  lang?: string;
}

export const Impressum: FunctionComponent<ImpressumProps> = (
  props: ImpressumProps
) => {
  return props.lang === "de" ? (
    <section>
      <div className="container text-center text-md-left">
        <h2 className="mb-4">Impressum</h2>
        <h4>Kontakt-Adresse</h4>

        <address>
          VSETH - Verband der Studierenden an der ETH
          <br />
          Universitätstrasse 6
          <br />
          8092 Zürich
          <br />
          Schweiz
        </address>

        <p>E-Mail: vseth@vseth.ethz.ch</p>
        <h4>Vertretungsberechtigte Person(en)</h4>

        <ul>
          <li>Lewin Könemann, Präsident</li>
          <li> Joy Schuurmans Stekhoven, Vizepräsidentin </li>
        </ul>

        <h4>Haftungsausschluss</h4>

        <p>
          Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen
          Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und
          Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor
          wegen Schäden materieller oder immaterieller Art, welche aus dem
          Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
          Informationen, durch Missbrauch der Verbindung oder durch technische
          Störungen entstanden sind, werden ausgeschlossen.
        </p>

        <p>
          Alle Angebote sind unverbindlich. Der Autor behält es sich
          ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne
          besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die
          Veröffentlichung zeitweise oder endgültig einzustellen.
        </p>

        <p> </p>

        <h4>Haftungsausschluss für Links</h4>

        <p>
          Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres
          Verantwortungsbereichs. Es wird jegliche Verantwortung für solche
          Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten
          erfolgen auf eigene Gefahr des jeweiligen Nutzers.
        </p>
      </div>
    </section>
  ) : (
    <section>
      <div className="container text-center text-md-left">
        <h2 className="mb-4">Imprint</h2>
        <h4>Contact address</h4>
        VSETH - Association of Students at ETH Zurich
        <address>
          VSETH - Verband der Studierenden an der ETH
          <br />
          Universitätstrasse 6
          <br />
          8092 Zürich
          <br />
          Schweiz
        </address>
        <p>E-Mail: vseth@vseth.ethz.ch</p>
        <h4>Authorised representative persons</h4>
        <ul>
          <li>Lewin Könemann, President</li>
          <li> Joy Schuurmans Stekhoven, Vice President </li>
        </ul>
        <h4>Disclaimer</h4>
        <p>
          The author assumes no liability whatsoever with regard to the
          correctness, accuracy, up-to-dateness, reliability and completeness of
          the information provided. Liability claims against the author for
          damages of a material or immaterial nature arising from access to or
          use or non-use of the published information, from misuse of the
          connection or from technical faults are excluded.
        </p>
        <p>
          All offers are non-binding. The author expressly reserves the right to
          change, supplement or delete parts of the pages or the entire offer
          without special notice or to temporarily or permanently cease
          publication.
        </p>
        <h4>Disclaimer for links</h4>
        <p>
          References and links to third-party websites are outside our area of
          responsibility. Any responsibility for such websites is rejected.
          Access to and use of such websites is at the user's own risk.
        </p>
      </div>
    </section>
  );
};
